import api from './api'

export const sessionApi = {
  // Access with PIN (new endpoint for waiting room flow)
  async accessWithPin(pinCode) {
    try {
      const response = await api.post(`/pins/${pinCode}/access`)
      return {
        success: true,
        data: response.data || response,
      }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || error.message || 'Access error',
        error,
      }
    }
  },

  // Get session status (Student polling)
  async getSessionStatus(pinCode) {
    try {
      const response = await api.get(`/sessions/${pinCode}/status`)
      return {
        success: true,
        data: response.data || response,
      }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || error.message || 'Error getting session status',
        error,
      }
    }
  },

  // Get session details (Teacher)
  async getSession(pinCode) {
    try {
      const response = await api.get(`/sessions/${pinCode}`)
      return {
        success: true,
        data: response.data || response,
      }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || error.message || 'Error getting session',
        error,
      }
    }
  },

  // Start session (Teacher)
  async startSession(pinCode) {
    try {
      const response = await api.post(`/sessions/${pinCode}/start`)
      return {
        success: true,
        data: response.data || response,
      }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || error.message || 'Error starting session',
        error,
      }
    }
  },

  // Complete session (Teacher)
  async completeSession(pinCode) {
    try {
      const response = await api.post(`/sessions/${pinCode}/complete`)
      return {
        success: true,
        data: response.data || response,
      }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || error.message || 'Error completing session',
        error,
      }
    }
  },

  // Remove student from session (Teacher)
  async removeStudent(pinCode, studentId) {
    try {
      const response = await api.delete(`/sessions/${pinCode}/students/${studentId}`)
      return {
        success: true,
        data: response.data || response,
      }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || error.message || 'Error removing student',
        error,
      }
    }
  },

  // Leave session (Student)
  async leaveSession(sessionId) {
    try {
      const response = await api.post(`/sessions/${sessionId}/leave`)
      return {
        success: true,
        data: response.data || response,
      }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || error.message || 'Error leaving session',
        error,
      }
    }
  },

  // Finish session (Student)
  async finishSession(sessionId) {
    try {
      const response = await api.post(`/sessions/${sessionId}/finish`)
      return {
        success: true,
        data: response.data || response,
      }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || error.message || 'Error finishing session',
        error,
      }
    }
  },
}
